import { getCommonStyle } from './styleCommon';
import crosshair from './tool/crosshair';
import fibonacciTools from './tool/fibonacciTools';

export function getToolStyles() {

	const commonAccentPrimary = getCommonStyle('color.accent.primary');
	const commonLineWidth = getCommonStyle('line.width');
	const commonFontFamily = getCommonStyle('font.family');

	return {
		arrow: {
			arrow: {
				height: 15,
				width: 5
			},
			background: {
				color: 'steelblue'
			},
			color: 'steelblue',
			width: 2
		},
		edgeHandle: {
			background: {
				color: null
			},
			color: null,
			hover: {
				background: {
					color: null
				},
				color: null
			},
			width: 20
		},
		ellipse: {
			background: {
				color: '#0001'
			},
			boundingBox: {
				color: '#000',
				lineDash: '2,3'
			},
			color: '#000',
			width: 1
		},
		extendedHorizontal: {
			support: {
				color: 'limegreen',
				width: 2
			},
			resistance: {
				color: 'red',
				width: 2
			},
			default: {
				color: 'pink',
				width: 2
			}
		},
		extendedLine: {
			color: 'orange',
			width: 2
		},
		...fibonacciTools,
		gannFan: {
			color: [
				'#666',
				'darkred',
				'orange',
				'#A8A800',
				'darkgreen'
			],
			gannLabels: ['1/1', '1/2', '1/3', '1/4', '1/8'],
			thresholds: [1, 0.5, 0.333, 0.25, 0.125],
			width: 1,
			label: {
				color: null,
				font: {
					family: 'Arial, Helvetica, sans-serif',
					size: 12,
					weight: 'normal'
				}
			}
		},
		handle: {
			hover: { // when the tool is unselected and handle is hovered
				background: {
					color: '#EEE' // fill color
				},
				color: '#999', // border color
				length: 9.5, // circle radius
				width: 1.5 // stroke width
			},
			background: {
				color: '#EEE' // fill color
			},
			color: '#999', // border color
			length: 7.5, // circle radius
			width: 1.5, // stroke width
			shape: 'default' // Circle, no other option at the moment
		},
		horizontalLine: {
			color: commonAccentPrimary,
			width: 1
		},
		line: {
			color: '#80B9FF',
			width: commonLineWidth
		},
		measurementLine: {
			background: {
				color: '#0001'
			},
			color: '#2496F1',
			font: {
				family: commonFontFamily,
				size: 14,
				weight: 'normal'
			},
			label: {
				background: {
					border: {
						color: '#AAA',
						lineDash: '1,0',
						width: 1.5
					},
					color: '#FFF',
					radius: 3,
					padding: {
						left: 8,
						right: 8,
						top: 4,
						bottom: 2
					}
				},
				margin: 10,
				color: '#333'
			},
			width: commonLineWidth
		},
		crosshair,
		ohlcCrosshair: {
			horizontal: {
				color: '#333333',
				width: 1
			},
			vertical: {
				color: '#333333',
				width: 1
			},
			shadow: {
				blur: 14,
				color: 'rgba(0, 0, 0, 0.5)'
			}
		},
		ray: {
			color: 'purple',
			width: 2
		},
		rectangle: {
			background: {
				color: 'transparent'
			},
			color: 'darkred',
			width: 2
		},
		returnsCalculator: {
			center: {
				background: {
					color: '#FFFFFF11'
				}
			},
			side: {
				background: {
					color: '#FFFFFFBF'
				},
				color: '#333333',
				width: 1
			}
		},
		snapHandle: {
			color: 'orange'
		},
		text: {
			background: {
				color: 'transparent'
			},
			boxHeight: 70,
			boxWidth: 200,
			color: '#000',
			font: {
				family: commonFontFamily,
				size: 14,
				weight: 'normal'
			},
			lineDash: '2,3',
			text: {
				color: '#333',
				lineHeight: 1.35
			},
			width: 1
		}
	};
}
